const PlayStoreLogo = ({ color = "#212B37", size = 17 }) => (
	<svg
		width={size}
		height={size + 1}
		viewBox="0 0 17 18"
		fill={color}
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M.5 1.442v15.115a.167.167 0 0 0 .283.119L8.653 9 .784 1.324a.167.167 0 0 0-.283.118Zm11.454 4.404L2.085.41 2.08.406c-.17-.093-.331.137-.192.271l7.736 7.397 2.33-2.228ZM1.888 17.323c-.14.134.021.364.192.271l.006-.003 9.868-5.437-2.331-2.229-7.735 7.398Zm14.05-9.285-2.756-1.517L10.591 9l2.591 2.478 2.756-1.516c.75-.415.75-1.51 0-1.924Z"
			fill={color}
		/>
	</svg>
);
export default PlayStoreLogo;
